import React from 'react';
import StarRatings from 'react-star-ratings';

const containerAlignClass = {
    left: 'ratingCount-left',
    right: 'ratingCount-right',
    bottom: 'ratingCount-bottom'
};

export const Rating = (props) => {
    const { averageRating, reviewCount, align, isRatingCount, isAverageRatingCount, starDimension, isVisibleMapView, starSpacing, starClassName, containerClass } = props;
    const children = React.Children.map(props.children, child => {
        if (child.type === Stars && averageRating && averageRating !== "" && averageRating !== '0') {
            return (<Stars averageRating={averageRating} align={align} starDimension={starDimension} starSpacing={starSpacing} isVisibleMapView={isVisibleMapView} starClassName={starClassName} />);
        } else if (isRatingCount === true && child.type === RatingCount) {
            return React.cloneElement(child, {
                averageRating,
                reviewCount,
                align,
                isAverageRatingCount
            });
        }
        else if (isRatingCount === false && child.type === RatingCount) {
            return null;
        }
        else {
            return child;
        }
    });

    let alignClass = '';
    switch (align) {
        case 'left':
            alignClass = containerAlignClass.left;
            break;
        case 'right':
            alignClass = containerAlignClass.right;
            break;
        case 'bottom':
            alignClass = containerAlignClass.bottom;
            break;
        default:
            alignClass = containerAlignClass.bottom;
    }
    let dynamicContainerClass = (alignClass ? alignClass : "") + " " + (containerClass ? containerClass : "");

    return (
        <div className={"rating-container " + (dynamicContainerClass ? dynamicContainerClass : "")}>
            {children}
        </div>
    );
};

export const RatingCount = ({ averageRating, reviewCount, isAverageRatingCount, align, ratingCountClassName }) => {
    return (<><div className={"overall-rating " + (ratingCountClassName ? ratingCountClassName : "")}>
        {isAverageRatingCount && parseFloat(averageRating).toFixed(1)}
        {reviewCount && <> ({reviewCount})</>}<sup>*</sup>
    </div></>);
};

export const Stars = ({ averageRating, align, starDimension, isVisibleMapView, starSpacing, starClassName }) => {
    return (<>
        <div className={"star-rating-container " + (starClassName ? starClassName : "")}>
            <StarRatings
                rating={parseFloat(averageRating)}
                starRatedColor={"#FFB71B"}
                numberOfStars={5}
                name="rating"
                starDimension={starDimension ? starDimension : "12px"}
                starSpacing={starSpacing ? starSpacing : "1px"}
            />
        </div>
        {isVisibleMapView ? <div className="star-rating-container star-rating--mapCard">
            <StarRatings
                rating={parseFloat(averageRating)}
                starRatedColor={"#FFB71B"}
                numberOfStars={5}
                name="rating"
                starDimension="8px"
                starSpacing="1px"
            />
        </div> : <></>}
    </>
    );
};

export default Rating;